module.exports = __webpack_public_path__ + "static/media/he-IL.19d9c4c0.md";